var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CollapsibleArea',{attrs:{"title":"Global Analytics"}},[_c('GlobalAnalytics')],1),_c('CollapsibleArea',{attrs:{"extraClasses":"mod-gradient","title":"Analytics by Tour"}},[_c('TourList')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }